import { User } from '../../types/users';
import StyledModal from '../shared/StyledModal';
import { UserForm } from './UserForm';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  userId?: string;
  user?: User;
  onSubmitFinished?: () => void;
};

export function UserModal({ isOpen, onClose, userId, user, onSubmitFinished }: Readonly<Props>) {
  const editMode = userId !== undefined && user !== undefined;

  return (
    <StyledModal
      isOpen={isOpen}
      closeable
      onClose={onClose}
      size="auto"
      title={editMode ? 'Editar ' : 'Nuevo '}
      content={
        <UserForm
          userId={userId}
          user={user}
          onCancel={onClose}
          onSubmitFinished={onSubmitFinished}
        />
      }
    />
  );
}
